<div class="wrapper" tabindex="-1" [class.sm]="size === Size.Small">
  <div class="d-flex align-items-center flex-grow-1">
    <label class="label flex-2">{{label}}</label>
    <a *ngIf="info" class="info" [routerLink]="infoLink" tabindex="-1" [ga]="infoEvent">{{info}}</a>
    <a *ngIf="help" href="javascript: void(0);" tabindex="-1" (click)="onHelpClick()">
      <img src="assets/images/icons/note.svg" class="icon-sm" alt="?">
    </a>
  </div>
  <div [ngClass]="{'d-flex justify-content-between align-items-center flex-grow-1': suffix}">
    <ng-content class="input flex-grow-1"></ng-content>
    <span class="input-suffix" *ngIf="suffix">{{suffix}}</span>
  </div>
</div>
<div *ngIf="isError" class="error pt-1 text-danger text-sm">{{error}}</div>
<div *ngIf="!error && hint" class="hint pt-1 text-gray text-sm">{{hint}}</div>
